import { GlobalReactQueryOptions } from '../../../config';
import { useQuery } from '@tanstack/react-query';
import { fetchPromotionData } from './fetchPromotionData';

const PROMOTION_DATA_KEY = 'promotion-data';

interface Props {
    campaignProductId: string;
    enabled?: boolean;
}
export const usePromotionData = ({ campaignProductId, enabled }: Props) => {
    return useQuery(
        [PROMOTION_DATA_KEY, campaignProductId],
        () => {
            return fetchPromotionData(campaignProductId);
        },
        {
            ...GlobalReactQueryOptions,
            enabled
        }
    );
};
